import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { isUndefined, isEqual, map } from 'lodash';
import { bindActionCreators } from 'redux';
import utils, { constants } from '@utils';
import Actions from '@redux/reports';
import ReportsTable from './reportsTable';
import {
	clientOverviewColumns, officerOverviewJobColumns, officerOverviewLocationColumns, officersColumns, projectsColumns,
} from '../utils/columnsDefinition';

class LocationOverviewReport extends Component {
	constructor(props) {
		super(props);

		this.reportOverviewData = [];
	}

	shouldComponentUpdate = ({ reportData }) => {
		const lastProps = this.props;

		return (!isEqual(reportData, lastProps.reportData));
	}

	UNSAFE_componentWillReceiveProps = ({ reportData }) => {
		const lastProps = this.props;

		if (!isEqual(reportData, lastProps.reportData)) this.reportOverviewData = this.updateReportOverviewData(reportData);
	}

	componentWillUnmount = () => {
		const { resetReportsListData } = this.props;
		resetReportsListData();
	}

	updateReportOverviewData = (reportData) => [
		{
			empty                 : 'Scheduled',
			jobCount              : !isUndefined(reportData.ScheduledJobCount) ? reportData.ScheduledJobCount : 'N/A',
			projects              : !isUndefined(reportData.ScheduledProjectsCount) ? reportData.ScheduledProjectsCount : 'N/A',
			totalHours            : !isUndefined(reportData.TotalScheduledHours) ? reportData.TotalScheduledHours : 'N/A',
			locationsCount        : !isUndefined(reportData.TotalLocationScheduledCount) ? reportData.TotalLocationScheduledCount : 'N/A',
			officersAssignedCount : !isUndefined(reportData.TotalOfficersScheduledCount) ? reportData.TotalOfficersScheduledCount : 'N/A',
		},
		{
			empty                 : 'Worked',
			jobCount              : !isUndefined(reportData.WorkedJobCount) ? reportData.WorkedJobCount : 'N/A',
			projects              : !isUndefined(reportData.WorkedProjectsCount) ? reportData.WorkedProjectsCount : 'N/A',
			totalHours            : !isUndefined(reportData.TotalWorkedHours) ? reportData.TotalWorkedHours : 'N/A',
			locationsCount        : !isUndefined(reportData.TotalLocationWorkedCount) ? reportData.TotalLocationWorkedCount : 'N/A',
			officersAssignedCount : !isUndefined(reportData.TotalOfficersWorkedCount) ? reportData.TotalOfficersWorkedCount : 'N/A',
		},
	];

	render() {
		const { reportData, TimeZoneId } = this.props;
		return (
			<Fragment>
				<h3 className="font-size-24 font-regular color-gray-oxford">Client Overview Report</h3>
				<Row className="padding-top-20 hidden-print">
					<Col md={12}>
						<div className="panel-summary bg-white rate-stats-bottom-border">
							<div className="col">
								<h3 className="padding-left-15 font-size-24 font-regular color-gray-oxford">{ reportData.AgencyName || 'Client Name' }</h3>
								<div className="list-element padding-15">
									<div className="col">Client First Start Date</div>
									<div className="col">
										{ reportData.AgencyFirstStartDate
											? utils.parseUTCDateToTimeZone(reportData.AgencyFirstStartDate, TimeZoneId).format('MM/DD/YYYY')
											: '' }
									</div>
								</div>
							</div>
						</div>
						<ReportsTable
							data={this.reportOverviewData}
							tableColumn={clientOverviewColumns('clientOverview')}
						/>
					</Col>

				</Row>
				<ReportsTable
					header="Projects"
					data={reportData.ProjectJobOverviewList || []}
					tableColumn={projectsColumns}
				/>
				<ReportsTable
					header="Jobs"
					data={reportData.JobOverviewList || []}
					tableColumn={officerOverviewJobColumns(TimeZoneId)}
				/>
				<div className="text-right padding-right-10">
					<div className="color-gray-dove">Alerts: </div>
					{ map(constants.JOBS_ALERTS_LEGEND, (item, key) => (
						<Fragment key={`job_alert_legend_item_${key}`}>
							<span className="font-black color-gray-dove">
								{ key }
								{' '}
								=
								{' '}
							</span>
							<span className="color-gray-dove">{ `${item}${key !== 'O' ? ', ' : ''}` }</span>
						</Fragment>
					)) }
				</div>
				<ReportsTable
					header="Locations"
					data={reportData.LocationJobOverviewList || []}
					tableColumn={officerOverviewLocationColumns('Location')}
				/>
				<ReportsTable
					header="Officers"
					data={reportData.OfficerJobOverviewList || []}
					tableColumn={officersColumns}
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	reports : {
		reportData,
	}, app: { user: { TimeZoneId } },
}) => ({
	reportData,
	TimeZoneId,
});

const mapDispatchToProps = (dispatch) => ({
	resetReportsListData : bindActionCreators(Actions, dispatch).resetReportsListData,
});

LocationOverviewReport.propTypes = {
	TimeZoneId           : PropTypes.string,
	reportData           : PropTypes.object,
	resetReportsListData : PropTypes.func.isRequired,
};

LocationOverviewReport.defaultProps = {
	TimeZoneId : '',
	reportData : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationOverviewReport);
